import { Theme, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: "#16151C",
    },
    fontFamily: "Lexend",
    fontWeight: 300,
    fontSize: 14,
  },
  buttonPrimaryStyle: {
    height: "50px",
    backgroundColor: "rgb(113, 82, 243) !important",
    borderRadius: "10px !important",
    marginLeft: "10px !important",
    fontSize: "14px !important",
  },
  buttonSecondaryStyle: {
    borderRadius: "10px !important",
    height: "50px",
    borderColor: "#7152F3 !important",
    color: "#7152F3 !important",
    marginLeft: "10px !important",
    fontSize: "12px !important",
    padding:"10px !important",
  },
  buttonSecondaryStyleSmall: {
    borderRadius: "10px !important",
    borderColor: "#7152F3 !important",
    color: "#7152F3 !important",
    marginLeft: "10px !important",
    fontSize: "10px !important",
    lineHeight: "12px !important",
    padding:"5px !important",
  },
  buttonStyle: {
    height: "50px",
    border: "none",
    color: "#7152F3 !important",
    fontSize: "13px !important",
  },
  inputTextStyle: {
    width: "100%",
    border: "1px solid #A2A1A833",
    borderRadius: "10px",
    height: "50px",
    paddingLeft: "10px",
  },
  buttonAction: {
    borderRadius: "4px !important",
    height: "29px",
    borderColor: "#7152F3 !important",
    color: "#7152F3 !important",
    marginLeft: "10px !important",
    fontSize: "12px !important",
  },
  tableContainer: {
    padding: 19,
    paddingLeft: 0,
    paddingRight: 0,
  },
  navContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #A2A1A833",
    marginLeft: "15px",
    marginRight: "15px",
  },
  navItem: {
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: "#16151C",
    fontWeight: 300,
    fontFamily: "Lexend",
     padding: "5px 10px",
    fontSize: "14px",
    lineHeight: "20px",
  },
  selectedNavItem: {
    border: "none",
    fontFamily: "Lexend",
    borderBottom: "3px solid #7152F3",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: "#7152F3",
    fontWeight: 500,
    padding: "5px 10px",
    fontSize: "14px",
    lineHeight: "20px",
  },

  searchContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    maxWidth:"300px",
  },

  search: {
    position: "relative",
    marginLeft: 0,
    width: "100%",
    display: "flex",
    height: 50,
    marginRight: 20,
  },
  searchicon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#16151C",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
    border: "1px solid #A2A1A81A",
    borderRadius: 10,
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px) !important`,
    transition: theme.transitions.create("width"),
    width: "100%",
  },
  marqueeContainer: {
    width: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    backgroundColor: "#F3F2FC",
    padding: "6px 0",
    borderRadius: "6px",
    marginTop: "10px",
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    position:"absolute",
    top:0,
    left:0
  },
  marqueeText: {
    display: "flex",
    width: "max-content",
    animation: "$marquee 40s linear infinite",
    fontWeight: 500,
    fontSize: "12px",
    fontFamily: "Lexend",
  },
  "@keyframes marquee": {
    "0%": {
      transform: "translateX(0)",
    },
    "100%": {
      transform: "translateX(-50%)",
    },
  },
  selectionBox: {
    border: "1px solid #E0E0E0",
    borderRadius: "10px",
    padding: "15px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
    "&:hover": {
      borderColor: "#7152F3",
      backgroundColor: "#F3F2FC",
    },
  },
  selectionBoxSelected: {
    border: "1px solid #7152F3",
    backgroundColor: "#F3F2FC",
  },
  selectionTitle: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#16151C",
    fontFamily: "Lexend",
  },
}));

export default useStyles;
